<template>
    <page-container>
        <template v-slot:page-fixed-header>
            <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
                $t("menu.businessPerformance")
            }}</span>
            <v-tabs :key="render" class="a-tabs pt-3 pr-5 tab-align-lang-style" v-model="selectedTab" show-arrows
                height="38" style="background-color: var(--v-Neutral-base)" right @change="onTabChange">
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab class="consolidated">
                    {{ $t("business.lblConsolidated") }}
                </v-tab>
                <v-tab class="byCompany">
                    {{ $t("business.lblByCompany") }}
                </v-tab>
            </v-tabs>
        </template>
        <template v-slot:page-content>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-tabs-items v-model="currentTab">
                        <v-tab-item>
                            <ConsolidatedTab @renderTab="handleRenderTab"></ConsolidatedTab>
                        </v-tab-item>
                        <v-tab-item>
                            <CompanyTab @renderTab="handleRenderTab"></CompanyTab>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
        </template>
    </page-container>
</template>

<script>
import { mapActions } from "vuex";
import List from "@/components/settings/list.vue";
import Loader from "@/components/Loader.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import CompanyTab from "./CompanyTab.vue";
import ConsolidatedTab from "./ConsolidatedTab.vue";

export default {
    name: "BusinessSettings",
    mixins: [SignalRMixin],
    data() {
        return {
            render: 0,
            selectedTab: 0,
            currentTab: 0,
            navigateTab: 0,
        };
    },
    components: {
        CompanyTab,
        ConsolidatedTab,
        List,
        Loader,
    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            async handler() {
                this.render++;
            }
        }
    },
    mounted(){
        this.render++;
    },
    methods: {
        ...mapActions({
            setLCATab: "agenda/setLCATab"
        }),
        onTabChange,
        handleRenderTab(){
            this.render++
        }
    },
};


function onTabChange() {
    this.$nextTick(() => {
        this.navigateTab = this.selectedTab;
        this.selectedTab = this.currentTab;
        this.isPrevent = true;
    });
    this.currentTab = this.selectedTab;
    this.setLCATab(this.currentTab)
}

</script>
<style scoped>
::v-deep .theme--dark.v-tabs>.v-tabs-bar {
    /* background-color: #1E1E1E; */
    background: transparent !important;
}

.a-tabs .v-tab--active {
    background: #dde3ee;
}
</style>